import React, { useEffect, useState, useContext } from "react";
import Select from "react-select";
import { apiService } from "../../service/ApiService";
import { Form } from "react-bootstrap";
import StoreContext from "contexts/StoreContext";

import { useTranslation } from "react-i18next";

const GeneralStoreSelect = ({ title, handler = null, disabled, selectedStoreId }) => {
  const {
    t,
  } = useTranslation();

  title = title === undefined ? t("forms.placeholders.selectStore") : title;
  const [stores, setStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState(null);
  const { storeId, setStoreId } = useContext(StoreContext);

  const sendStoreId = () => {
    selectedStoreId(storeId);
  };

  const handleChange = (e) => {
    setSelectedStore(e);
    sendStoreId();
    if (e) handler(e.value);
    else handler(null);
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const getStores = async () => {
    try {
      const response = await apiService.get(`api/v1/stores`);
      const availableStores = response.data.map((el) => {
        return {
          value: el.id,
          label: el.name,
        };
      });
      setStores(availableStores);
    } catch (error) {
      console.error(error);
    }
  };

  const setNewValue = () => {
    const selectedStore = stores.find((el) => el.value === storeId);
    if (selectedStore) setSelectedStore(selectedStore);
  };

  useEffect(() => {
    getStores();
  }, []);

  useEffect(() => {
    setNewValue();
  }, [stores]);

  useEffect(() => {
    setNewValue();
    sendStoreId();
  }, [storeId]);

  return (
    <>
      <Form.Group>
        <label>{title}</label>
        <Select
          styles={customStyles}
          isDisabled={disabled}
          isClearable={true}
          className="primary"
          name="storeSelect"
          onChange={handleChange}
          value={selectedStore}
          options={stores}
          noOptionsMessage={() => t("messages.noStoresAreAvailable")}
          placeholder={`${t("common.actions.select")} ${title}`}
        />
      </Form.Group>
    </>
  );
};

export default GeneralStoreSelect;
